<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja"class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
          </li>
          <li class="item-link">
            <span>{{ NomeCategoria }}</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="box-title first">{{NomeCategoria}}</h3>
          </div>
        </div>
        <div class="row">
          <Loader v-if="loadingProducts" />
          <div class="col-md-3" v-for="(product, index) in this.produtos" :key="index">
            <div class="product product-style-2 equal-elem row product-box-size">
              <div class="product-thumnail align-center">
                <a href="#" :title="product.name">
                    <figure class="product-box-image">
                      <img :src="product.img" :alt="product.name" class="product-image-size  col-md-12" />
                      <!-- <img :src="product.img" width="800" height="800" :alt="product.name" /> -->
                    </figure>
                </a>
              </div>
              <div class="product-info row align-center">
                <div class="col-md-12">
                  <div class="row" style="min-height: 20px;">
                    <span class="product-code">Código: {{ product.code }}</span>
                  </div>
                  <div class="row" style="min-height: 80px;">
                    <h3>
                      <a href="#" class="product-name">
                        <span>{{ product.name }}</span>
                      </a>
                    </h3>
                  </div>
                  <div class="row" style="min-height: 80px;">
                      <p class="product-description">{{ product.description }}</p>
                  </div>  
                  <div class="row">
                    <p>
                      <a
                        href="#"
                        data-toggle="modal"
                        data-target="#default-modal"
                        @click.prevent="openModal(product.id)"
                      >
                        <i class="fa fa-info"></i> mais informações
                      </a>                  
                    </p>
                  </div>

                  <div class="row">
                      <div v-if="!product.promotionalPrice" class="wrap-price-resgate">
                        <span class="product-price">{{ formatPrice(product.price) }}</span>
                      </div>
                      <div v-else class="wrap-price-resgate">
                        <ins>
                          <p class="product-price">{{ formatPrice(product.promotionalPrice) }}</p>
                        </ins>
                      </div>
                    </div>
                </div>
              </div>

              <div v-if="product.showActions" class="actions row">
                <div class="action-buy width-100">
                  <button aria-label="Adicionar Carrinho" class="btn primary-button width-100" @click.prevent="addCar(product.code)">
                    Resgate Agora
                    <i class="fa fa-shopping-cart"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <modal-default
        v-bind:title="produtoInfo.name"
        width="70"
        v-if="showModal"
        @close="showModal = false"
      >
        <slot>
          <div class="row">
            <div class="col-sm-12 text-center">
              <Loader v-if="loadingProductDetail" />
              <img
                v-bind:src="produtoInfo.img"
                width="160"
                height="120"
                id="imgProdutoPreview"
                alt
              />
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 text-left">
                <br>
              <div class="lbDescricaoTecnica" v-html="produtoInfo.description"></div>
            </div>
          </div>
          <div
            class="alert alert-warning"
            role="alert"
          >
            INFORMAÇÕES IMPORTANTES
            <br />• Solicitações não finalizadas, são canceladas automaticamente, 48 em horas;
            <br />• Toda solicitação de produto seguirá bonificado para sua empresa juntamente com o seu próximo pedido;
            <br />• A partir da data da colocação de sua solicitação, você terá 3 dias corridos, para realizar seu próximo pedido na Aldo, no qual os itens bonificados seguirão, conforme descrito no ponto acima. Após esta data limite, a solicitação é cancelada e o crédito de Aldolar é devidamente estornado;
          </div>
        </slot>
      </modal-default>
    </div>
  </main>
</template>
<script>
import ModalDefault from "./partials/ModalDefault.vue";

export default {
  name: "CrazyCategory",
  components: {
    ModalDefault
  },
  computed: {
    NomeCategoria: function() {
      // com base no ID da categoria retornar nome
      switch(this.$route.params.id){
        case "0":
          return "Showroom";
          break;
        case "5":
          return "Produtos e Utilitário";
          break;
        case "11":
          return "Ferramentas";
          break;
        case "4":
          return "Brindes";
          break;
        //case "2":
        //  return "Treinamentos e Eventos";
        //  break;
        default:
          return "CrazyCard"
      }     
    }
  },
  mounted(){
    this.getProdutos();
  },
  data() {
    return {
      showModal: false,
      loadingProducts: true,
      loadingProductDetail: false,
      produtoInfo: {
        img:"",
        name: "",
        description: ""
      },
      produtos: []
    };
  },
  methods: {
    formatPrice: function(price) {
      return (
        "A$" +
        price.toLocaleString("pt-BR", {
          // Ajustando casas decimais
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      );
    },
    openModal: function(code) {      
      this.loadingProductDetail = true;
      var xhr = new XMLHttpRequest();
      xhr.onload = () => {
        if (xhr.status == 200){
         if(xhr.responseText != "" && xhr.responseText != null){             
            let json = JSON.parse(xhr.responseText);      
            this.loadingProductDetail = false;
            this.produtoInfo.img = json.PrdCaminho;
            this.produtoInfo.name = json.DescricaoPrincipal;
            this.produtoInfo.description = json.DescicaoTecnica;      
            // this.produtoInfo.description = json.DescicaoTecnica.split('|')[2];      
          }          
        }
      }
      xhr.open("POST", this.$apiUrl + "ProdutoCrazy.svc/descricaoproduto");
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.withCredentials = true;
      xhr.send(JSON.stringify({ codigoProduto: code }));   
      
      this.showModal = true;

    },
    getProdutos: function(){
      this.loadingProducts = true;
      var xhr = new XMLHttpRequest();
      xhr.onload = () => {
        if (xhr.status == 200){
         if(xhr.responseText != "" && xhr.responseText != null){             
            let json = JSON.parse(xhr.responseText);
            this.loadingProducts = false;
            json.forEach((element, index) => {
              this.produtos.push(
               new this.$product({
                  id: element.Aip.PrdCodigo,
                  code: element.Aip.CraCodigo,
                  name: element.PsgDescricao,
                  state: "PR",
                  img: element.PrdCaminho,
                  description: element.Descricao,
                  url: "#",
                  price: element.CraValor,
                  promotionalPrice: 0,
                  showActions: element.COD_CLIENTE > 0 ? true : false
                })
              )
            });
          }          
        }
      }
      xhr.open("POST", this.$apiUrl + "Menu.svc/getprodutosvalidos");
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.withCredentials = true;
      xhr.send(JSON.stringify({ categoria: parseInt(this.$route.params.id)}));     
    },
    addCar: function(code){
        //adiciona item ao carrinho
        var xhr = new XMLHttpRequest();
        xhr.onload = () => {
          if (xhr.status == 200){
            if(xhr.responseText != "" && xhr.responseText != null){             
              let json = JSON.parse(xhr.responseText);         
              if(json.IncluirProdutoViaCrazyStoreResult.split('|')[0] == "True"){
                swal({
                  title:"Sucesso",
                  text: "Item incluido em uma solicitação, confira no link Resgate/Nova Solicitação.",
                  icon: "success"
                })                                  
              }
              else{
                swal({
                  title:"Item não pode ser solicitado",
                  text: json.IncluirProdutoViaCrazyStoreResult.split('|')[1],
                  icon: "error"
                })  
              }
            }          
          }
        }
        xhr.open("POST", this.$apiUrl + "Resgate.svc/incluirproduto/crazystore");
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.withCredentials = true;
        xhr.send(JSON.stringify({ codigoProduto: parseInt(code)}));   
    }
  }
};
</script>
